import Link from '@/components/Link';
import TrainerPageSection from './TrainerPageSection';

export default function TrainerTrainings({ trainings }) {
  return (
    <TrainerPageSection title="Cursos que imparte">
      <div className="prose lg:prose-lg">
        <ul>
          {trainings.map(({ id, title, uri }) => (
            <li key={id}>
              <Link href={uri}>{title}</Link>
            </li>
          ))}
        </ul>
      </div>
    </TrainerPageSection>
  );
}
